"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apis = require("../../../../@apis");
var _hooks = require("../../../../@hooks");
var _functions = require("../../../../@functions");
var _constants = require("../../../../@constants");
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var masks = {
  company: _constants.docMasks.cnpj,
  autonomous: _constants.docMasks.cpf
};

/**
 * @typedef User
 * @type {import("./index.jsx").User}
 */

/**
 * @typedef StepProps
 * @type {import("./index.jsx").StepProps}
 */

/** @param {StepProps} props */
function AccountCreated(props) {
  var user = props.user;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Conta criada com sucesso", /*#__PURE__*/_react["default"].createElement("br", null), "Uma senha temporada foi enviada para ", /*#__PURE__*/_react["default"].createElement("strong", null, user.email)));
}
AccountCreated.propTypes = {
  user: _propTypes["default"].object.isRequired,
  goNext: _propTypes["default"].func.isRequired
};
var _default = AccountCreated;
exports["default"] = _default;